import React from 'react';

export const DefaultPageLayout = ({ children }) => {
    return (
        <div className="min-h-screen bg-white">
            <main className="flex-1">
                {children}
            </main>
        </div>
    );
}; 